import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { APP } from 'src/Configs/App'

export interface ApplyInvitedBonusResult {
  applied: boolean
}

export const referralBonusApi = createApi({
  reducerPath: 'referralBonusApi',
  baseQuery: fetchBaseQuery({
    baseUrl: APP.TIKTOK_SERVER,
  }),
  endpoints: (builder) => ({
    applyInvitedBonus: builder.mutation<
      ApplyInvitedBonusResult,
      { internalReferralCode: string; token: string }
    >({
      query: ({ internalReferralCode, token }) => ({
        url: '/artist/users/current/invited-bonus',
        method: 'POST',
        body: { internalReferralCode },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    signUpFirstPromoter: builder.mutation<
      void,
      { referralCode: string; token: string }
    >({
      query: ({ referralCode, token }) => ({
        url: '/artist/first-promoter/signup',
        method: 'POST',
        body: { referralCode },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
})

export const { useApplyInvitedBonusMutation, useSignUpFirstPromoterMutation } =
  referralBonusApi
